import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { authUserSchema } from "@/modules/auth/schemes";
import { CustomerHistoryPage } from "@/modules/customers/pages/CustomerHistory.page";

const customerHistorySearchSchema = z.object({
	page: z.coerce.number().int().min(1).optional().default(1),
});

export const Route = createFileRoute("/__authed/m/customers/history")({
	validateSearch: (search) => customerHistorySearchSchema.parse(search),
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;
		const parsedUser = authUserSchema.safeParse(user);

		if (!parsedUser.success || parsedUser.data.role.slug !== "store") {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const context = Route.useRouteContext();
	const search = customerHistorySearchSchema.parse(Route.useSearch());
	const navigate = Route.useNavigate();
	const rawUser =
		context && typeof context === "object" && "user" in context ? context.user : undefined;
	const parsedUser = authUserSchema.safeParse(rawUser);
	const user = parsedUser.success ? parsedUser.data : undefined;

	return (
		<CustomerHistoryPage
			clientId={user?.personId}
			page={search.page}
			onPageChange={(page) => {
				navigate({ search: { page } });
			}}
		/>
	);
}
